import { render, staticRenderFns } from "./TirantCloudWrapper.vue?vue&type=template&id=c9fd6cee&lang=pug&"
import script from "./TirantCloudWrapper.vue?vue&type=script&lang=js&"
export * from "./TirantCloudWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports